export type SupportCarModel =
  | "truck"
  | "fullSizeCar"
  | "oneBoxCar"
  | "midSizeCar"
  | "compactCar"
  | "kCar"
  | "motorcycle";

// バイク：motorcycle
// 軽自動車：kCar
// コンパクトカー：compactCar
// 中型車：
// ワンボックス：oneBoxCar
// 大型車（SUV）：fullSizeCar
// トラック・大型重量車両：truck

type SupportCarSize =
  | "トラック・大型重量車両"
  | "大型車・SUV"
  | "ワンボックス"
  | "中型車"
  | "コンパクトカー"
  | "軽自動車"
  | "バイク";

type SupportCarModelObject = {
  [K in SupportCarModel]: SupportCarSize;
};

const SUPPORT_CAR_MODEL: SupportCarModelObject = {
  truck: "トラック・大型重量車両",
  fullSizeCar: "大型車・SUV",
  oneBoxCar: "ワンボックス",
  midSizeCar: "中型車",
  compactCar: "コンパクトカー",
  kCar: "軽自動車",
  motorcycle: "バイク",
};

/**
 * @param supportCar SupportCarModel
 * @return SupportCarSize
 */
export const findLargestSupportCarModel = (supportCar: SupportCarModel): SupportCarSize => {
  switch (supportCar) {
    case "truck":
      return SUPPORT_CAR_MODEL.truck;
    case "fullSizeCar":
      return SUPPORT_CAR_MODEL.fullSizeCar;
    case "oneBoxCar":
      return SUPPORT_CAR_MODEL.oneBoxCar;
    case "midSizeCar":
      return SUPPORT_CAR_MODEL.midSizeCar;
    case "compactCar":
      return SUPPORT_CAR_MODEL.compactCar;
    case "kCar":
      return SUPPORT_CAR_MODEL.kCar;
    case "motorcycle":
      return SUPPORT_CAR_MODEL.motorcycle;
  }
};

type SupportCarModelObjectWithBoolean = {
  [K in SupportCarModel]: boolean;
};

export const findLargestSupportCarModelFromObject = (
  supportCarModelObject: SupportCarModelObjectWithBoolean
): SupportCarSize => {
  if (supportCarModelObject.truck) return SUPPORT_CAR_MODEL.truck;
  if (supportCarModelObject.fullSizeCar) return SUPPORT_CAR_MODEL.fullSizeCar;
  if (supportCarModelObject.oneBoxCar) return SUPPORT_CAR_MODEL.oneBoxCar;
  if (supportCarModelObject.midSizeCar) return SUPPORT_CAR_MODEL.midSizeCar;
  if (supportCarModelObject.compactCar) return SUPPORT_CAR_MODEL.compactCar;
  if (supportCarModelObject.kCar) return SUPPORT_CAR_MODEL.kCar;
  if (supportCarModelObject.motorcycle) return SUPPORT_CAR_MODEL.motorcycle;
  return SUPPORT_CAR_MODEL.motorcycle;
};

export type SupportCarModelNumber = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const switchSupportCarModelByNumber = (number: SupportCarModelNumber, isCustomer = false) => {
  switch (number) {
    case 0:
      return isCustomer ? "なし" : "";
    case 1:
      return SUPPORT_CAR_MODEL.kCar;
    case 2:
      return SUPPORT_CAR_MODEL.compactCar;
    case 3:
      return SUPPORT_CAR_MODEL.midSizeCar;
    case 4:
      return SUPPORT_CAR_MODEL.oneBoxCar;
    case 5:
      return SUPPORT_CAR_MODEL.fullSizeCar;
    case 6:
      return SUPPORT_CAR_MODEL.truck;
    case 7:
      return SUPPORT_CAR_MODEL.motorcycle;
  }
};
